<div class="creators-container">
  <app-datatable
    [rowData]="dataSource().data"
    [columns]="datatableColumns"
    [configurationInput]="datatableConfig"
    [customColumnDef]="[
      { name: 'name', isSortable: true, template: nameColumn },
      { name: 'platforms', isSortable: false, template: platformsColumn },
      { name: 'campaigns', isSortable: true, template: campaignsColumn },
      { name: 'actions', isSortable: false, template: actionsColumn },
    ]"
    [total]="store.total$()"
    [loaderConfig]="skeletonLoaderConfig"
    [isInitialDataLoaded]="loadedTableData()"
    [loadingData]="creatorsLoading()"
    (rowClick)="onRowClick($event)"
  />

  <ng-template #nameColumn let-row="row" let-index="index">
    <div class="flex items-center gap-2">
      <app-icon-badge
        [content]="row.icon"
        [fallbackBackgroundColor]="index % 2 === 0 ? 'var(--shikenso-base-white)' : 'var(--shikenso-gray-base)'"
        [fallbackText]="row.name"
        [borderRadius]="100"
        [size]="40"
        [iconSize]="40"
        [fontSize]="16"
        alt="Avatar"
      />
      <span class="font-bold">{{ row.name }}</span>
    </div>
  </ng-template>

  <ng-template #platformsColumn let-row="row">
    <div class="flex items-center gap-2">
      @for (badge of row.platformList; track badge.id) {
        <app-social-badge
          backgroundColor="transparent"
          [type]="badge.platform"
          [size]="badge.platform === EPlatform.youtube ? 24 : 16"
          [iconSize]="badge.platform === EPlatform.youtube ? 24 : 16"
        />
      }
    </div>
  </ng-template>

  <ng-template #campaignsColumn let-row="row">
    <div class="flex items-center">
      <div class="w-9 h-9 flex items-center justify-center">
        <app-icon src="/icons/campaigns.svg" alt="Campaign" [size]="16" />
      </div>
      <span>{{ row.campaignCreators?.length }}</span>
    </div>
  </ng-template>

  <ng-template #actionsColumn let-row="row">
    <div *hasPermission="[EPermissions.creatorDeleteOwn]" class="flex items-center justify-start">
      <button
        mat-icon-button
        class="mat-secondary-transparent-button-color"
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
      >
        <app-icon src="/icons/three-dots.svg" alt="More" [size]="16" />
      </button>
      <mat-menu #menu="matMenu">
        <button *hasPermission="[EPermissions.creatorDeleteOwn]" mat-menu-item (click)="onDeleteClick($event, row)">
          {{ 'shared.form.delete' | translate }}
        </button>
      </mat-menu>
    </div>
  </ng-template>
</div>
